// src/v2/pages/Reports/SeparatedEmployeeReport.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useSeparatedEmployeeReport } from '../../hooks/useSeparatedEmployeeReport';
import { SeparatedEmployeeReportModule } from '../../components/modules/Reports/SeparatedEmployeeReport/SeparatedEmployeeReportModule';

const SeparatedEmployeeReport = ({ isHideSideMenu }) => {
  const reportHook = useSeparatedEmployeeReport();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportHookModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

// Internal fix to match the import naming used in the Page
const ReportHookModule = ({reportHook}) => <SeparatedEmployeeReportModule reportHook={reportHook} />;

export default SeparatedEmployeeReport;